import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-10 mx-auto" }
const _hoisted_2 = { class: "font-bold text-xl" }

import DataTable from "@/components/ui_custom/data-table/DataTable.vue";
  import {onMounted, ref, watch} from "vue";
  import { columns } from "./columns"
  import TablesService from "@/services/tables/tables.service";
  import useEventsBus from "@/utils/eventBus";
  import {Building} from "@/models/tables/building.interface";
  import {i18n} from "@/utils/i18n";
  import {toast} from "@/utils/utils";
  import router from "@/router";

  const entity = 'buildings';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingsTable',
  setup(__props) {

  const data = ref<Building[]>([]);
  const { bus } = useEventsBus();
  async function getData(): Promise<Building[]> {
    const res = await TablesService.getData(entity);
    return res?.data;
  }

  onMounted(async () => {
    data.value = await getData();
  })

  watch(() => bus.value.get('new_'+entity), async () => {
    await router.push({ name:'newBuilding', params: { id: 0 } });
  })

  watch(() => bus.value.get('delete_'+entity), async (value) => {
    await TablesService.deleteRecord(value, entity);
    data.value = data.value.filter(row => row.id !== value);
    toast.success(i18n.global.t('toast.delete_success'));
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('table.buildings_list')), 1),
    _createVNode(DataTable, {
      columns: _unref(columns),
      data: data.value,
      entity: entity
    }, null, 8, ["columns", "data"])
  ]))
}
}

})